const stringHelpers = require('../../../common/components/stringhelpers');

module.exports = function ($stateProvider, $urlRouterProvider, $locationProvider, $urlMatcherFactoryProvider) {
    $urlMatcherFactoryProvider.caseInsensitive(true);
    $urlMatcherFactoryProvider.strictMode(false);

    $locationProvider.hashPrefix('!');

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });

    // Configuring the stateProvider is actually quite expensive and so in tests, the below feature is 'enabled'
    // This is a HACK, temporary. Should be replaced with mocking stateProvider or switching routing library.
    if (window.wowFeatures.isEnabled('route-config-test-mode')) {
        return;
    }

    $stateProvider
        .state('root', {
            url: '',
            abstract: true,
            data: {
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata(null, false, null, 'Home');
                    }
                ]
            },
            views: {
                'header-panel': {
                    controller: [
                        'BreakpointsService', '$scope', 'BrowserWindowService', function (breakpointsService, $scope, browserWindowService) {
                            browserWindowService.init();
                            $scope.isSmallFormat = breakpointsService.isSmallFormat();
                            $scope.isMobileHeader = window.innerWidth < 768;

                            $scope.$on('window:resize', function () {
                                $scope.$apply(function () {
                                    $scope.isSmallFormat = breakpointsService.isSmallFormat();
                                    $scope.isMobileHeader = window.innerWidth < 768;
                                });
                            });
                        }
                    ],
                    template: '<wow-small-menu ng-if="isMobileHeader"></wow-small-menu><wow-global-header ng-if="!isMobileHeader"></wow-global-header>'
                },
                toolbar: {
                    template: '<wow-toolbar></wow-toolbar><wow-content-overlay></wow-content-overlay> <wow-store-picker-panel></wow-store-picker-panel>'
                },
                'mobile-nav@': {
                    template: '<wow-mobile-nav-menu></wow-mobile-nav-menu>'
                },
                'right-panel': {
                    controller: [
                        'ShopperService', '$scope', function (shopperService, $scope) {
                            $scope.shopper = shopperService;

                            $scope.orderManagementVisibility = {
                                isShowing: false
                            };
                        }
                    ],
                    template: '<wow-collection-zone class="cart-shop" show="orderManagementVisibility"></wow-collection-zone>'

                },
                'tracker-panel@': {
                    template: '<order-tracker></order-tracker>'
                },
                'center-panel@': {
                    controller: [
                        'BreakpointsService', '$scope',
                        function (breakpointsService, $scope) {
                            $scope.breakpointsService = breakpointsService;
                        }
                    ],
                    template: '<wow-seo-search></wow-seo-search>'
                }
            }
        })

        .state('home', {
            url: '^',
            parent: 'root',
            data: {
                richer_relevance: {
                    type: 'HOME_PAGE'
                },
                analytics: 'bws:web:homepage'
            },
            views: {
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        });

    $stateProvider
        .state('shop', {
            abstract: true,
            parent: 'root'
        })
        .state('shop.productdetails', {
            url: '/product/:productId/:productName',
            resolve: {
                deps: ['$$animateJs', '$ocLazyLoad', function ($$animateJs, $ocLazyLoad) {
                    console.log($$animateJs);
                    return $ocLazyLoad.load(window.wowModules[5].files[0]);
                }],

                productDetail: ['DetailProductService', '$stateParams', '$state', function (detailProductService, $stateParams, $state) {
                    const productId = $stateParams.productId;
                    const packDefaultStockCode = $stateParams.packDefaultStockCode;
                    if (!$state.$current.data) {
                        $state.$current.data = {};
                    }
                    return detailProductService.getProductDetail(productId, null, null, null, packDefaultStockCode).then((response) => {
                        detailProductService.cache = detailProductService.cache || {};
                        detailProductService.cache = response;

                        return response;
                    });
                }],

                recipeList: ['deps', 'RecipesService', 'productDetail', function (deps, recipesService, productDetail) {
                    if (productDetail && productDetail.Products && productDetail.Products[0].AdditionalDetails) {
                        const details = productDetail.Products[0].AdditionalDetails;
                        let recipeCategory = null;
                        for (let i = 0; i < details.length; i++) {
                            if (details[i].Name.toLowerCase() === 'recipecategory_urlfriendlydescription') {
                                recipeCategory = details[i].Value;
                                break;
                            }
                        }

                        if (recipeCategory) {
                            return recipesService.getRecipeList(recipeCategory + '?SortType=CreatedDesc').then((recipes) => {
                                return {
                                    items: recipes.Items,
                                    category: recipeCategory,
                                    description: recipes.Name
                                };
                            });
                        }
                    }

                    return {
                        items: [],
                        category: null,
                        description: null
                    };
                }]
            },
            data: {
                prerender: {},
                analytics: [
                    '$state', function ($state) {
                        if ($state.params.category) {
                            return `bws:web:pdp:${$state.params.category}:${$state.params.productName}`;
                        }
                    }
                ],
                pageMetadata: [
                    'DetailProductService', 'PageMetadataService', '$stateParams', 'currentProduct', function (detailProductService, pageMetadataService, $stateParams, currentProduct) {
                        const product = detailProductService.cache.defaultProduct;
                        currentProduct.id = $stateParams.productId;
                        currentProduct.title = product.Title;
                        currentProduct.vintage = product.ProductData.vintage;
                        return pageMetadataService.getMetadata({ name: stringHelpers.toTitleCase(product.Name) }, null, null, 'Product');
                    }
                ],
                canonicalUrl: ['DetailProductService', 'PageMetadataService', '$state', '$q', '$stateParams', function (detailProductService, pageMetadataService, $state, $q, $stateParams) {
                    const deferred = $q.defer();
                    const urlProductName = $state.params.productName;
                    const product = detailProductService.cache.defaultProduct;

                    deferred.resolve(pageMetadataService.getNormalizedCanonicalUrl(urlProductName, product.ProductData.bwsproducturl));

                    if (product.ProductData.bwsproducturl !== $stateParams.productName) {

                        const url = product.ProductData.bwsproducturl || '';

                        $state.$current.data.prerender = {
                            name: 'prerender-status-code',
                            value: '301',
                            location: window.location.origin + '/product/' + $stateParams.productId + '/' + url
                        };
                    } else {
                        $state.$current.data.prerender = {
                            name: null,
                            value: null,
                            location: null
                        };
                    }

                    return deferred.promise;
                }
                ],
                showBothPanelsInSmallFormat: true,
                richer_relevance: ['DetailProductService', '$stateParams', '$q', function (detailProductService, $stateParams, $q) {
                    const deferred = $q.defer();
                    const product = detailProductService.cache.defaultProduct;

                    let categoryId;
                    if (detailProductService.cache.parentProduct && detailProductService.cache.parentProduct.ProductData && detailProductService.cache.parentProduct.ProductData.defaultcategory) {
                        categoryId = detailProductService.cache.parentProduct.ProductData.defaultcategory;
                    }

                    deferred.resolve({
                        type: 'PRODUCT_PAGE',
                        data: { id: detailProductService.cache.defaultProduct.Stockcode.toString(), name: product.Title, categoryId }
                    });

                    return deferred.promise;
                }]
            },
            views: {
                'center-panel@': {
                    template: '<wow-detail-product-page></wow-detail-product-page>',
                    controller: [
                        '$stateParams', '$timeout', 'BreakpointsService', function ($stateParams, $timeout, breakpointsService) {
                            $timeout(function () {

                                const $body = $('body'),
                                    $reviews = $('#product-detail-reviews');

                                if ($stateParams.scrollToReviews && $reviews.length > 0) {

                                    $body.animate({
                                        scrollTop: $body.scrollTop() + $reviews.offset().top - breakpointsService.getScrollOffset()
                                    }, 200);
                                }
                            }, 2000);

                            // Bizaarvoice: Snare.js device finger print - basic configurations must be on page before snare.js
                            function configureIovation() {
                                window.io_install_stm = false;
                                window.io_exclude_stm = 12;
                                window.io_install_flash = false;
                                window.io_enable_rip = true;
                            }

                            configureIovation();
                        }
                    ]
                },

                'dynamic-content-bottom@': {
                    template: '<wow-recipe-carousel recipes="recipeItems" category="category" category-description="description"></wow-recipe-carousel>',
                    controller: ['$scope', 'recipeList', '$timeout', function ($scope, recipeList, $timeout) {
                        $timeout(() => {
                            $scope.recipeItems = recipeList.items;
                            $scope.category = recipeList.category;
                            $scope.description = recipeList.description;
                        }, 0);
                    }]
                }
            },
            params: { scrollToReviews: null, overwriteDefaultProduct: null, packDefaultStockCode: null, isBazaarvoiceCallEnabled: null, crossSellType: null, isSponsored: false, promoteIQCampaignId: null, source: null }
        })
        .state('shop.productdetails.reviews', {
            url: '/reviews',
            data: {
                analytics: [
                    '$state', function ($state) {
                        return `bws:web:pdp:reviews${$state.params}`;
                    }
                ],
                noIndex: true
            },
            views: {
                'center-panel@': {
                    controller: ['currentProduct', '$scope', function (currentProduct, $scope) {
                        $scope.currentProduct = currentProduct;
                    }],
                    template: '<wow-review-overview view-mode="all">' +
                        '<wow-product-review-heading title="All reviews for {{currentProduct.title}}"></wow-product-review-heading>' +
                        '</wow-review-overview>'
                }
            }
        })
        .state('shop.contact', {
            resolve: {
                deps: ['$ocLazyLoad', '$$animateJs', function ($ocLazyLoad, $$animateJs) {
                    console.log($$animateJs);
                    //Load the contact us bundle file
                    return $ocLazyLoad.load(window.wowModules[7].files[0]);
                }]
            },
            url: '/contact',
            data: {
                analytics: 'bws:web:contact'
            },
            views: {
                'center-panel@': {
                    template: '<wow-contact-us></wow-contact-us>'
                }
            }
        })
        .state('shop.misseddelivery', {
            url: '/dnrcd',
            data: {
                analytics: 'bws:web:gift missed delivery form'
            },
            views: {
                'center-panel@': {
                    template: '<wow-missed-delivery></wow-missed-delivery>'
                }
            }
        })

        .state('shop.rescheduledelivery', {
            url: '/rscdlv/:ordernumber',
            data: {
                analytics: 'bws:web:reschedule delivery form',
                pageMetadata: [
                    '$stateParams', function ($stateParams) {
                        return $stateParams.ordernumber;
                    }
                ],
            },
            views: {
                'center-panel@': {
                    template: '<wow-reschedule-delivery></wow-reschedule-delivery>'
                }
            }
        })

        .state('shop.pickupconfirmation', {
            url: '/pckcnf/:ordernumber',
            data: {
                analytics: 'bws:web:pickup confirmation form',
                pageMetadata: [
                    '$stateParams', function ($stateParams) {
                        return $stateParams.ordernumber;
                    }
                ],
            },
            views: {
                'center-panel@': {
                    template: '<wow-pickup-confirmation></wow-pickup-confirmation>'
                }
            }
        })

        .state('shop.rescheduleconfirmation', {
            url: '/rsccnf/:ordernumber/:day/:time',
            data: {
                analytics: 'bws:web:reschedule confirmation form',
                pageMetadata: [
                    '$stateParams', function ($stateParams) {
                        return {
                            ordernumber: $stateParams.ordernumber,
                            day: $stateParams.day,
                            time: $stateParams.time

                        };
                    }
                ],
            },
            views: {
                'center-panel@': {
                    template: '<wow-reschedule-confirmation></wow-reschedule-confirmation>'
                }
            }
        })

        .state('shop.app', {
            url: '/app',
            data: {
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'App - BWS Online' });
                    }
                ]
            },
            views: {
                'center-panel@': {
                    template: '<wow-app-empty></wow-app-empty>'
                },
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        })

        .state('shop.persistentlogin', {
            url: '/persistent-login',
            parent: 'root',
            data: {
                analytics: 'bws:web:persistent-login',
                authenticate: true
            },
            params: {
                intendedRoute: null
            },
            views: {
                'center-panel@': {
                    template: '<bws-persistent-login></bws-persistent-login>'
                }
            }
        })

        .state('shop.404error', {
            resolve: {
                deps: ['$ocLazyLoad', '$$animateJs', function ($ocLazyLoad, $$animateJs) {
                    console.log($$animateJs);
                    return $ocLazyLoad.load(window.wowModules[6].files[0]);
                }]
            },
            url: '/resource-not-found',
            parent: 'root',
            views: {
                'center-panel@': {
                    template: '<bws-error-page error-page=\'404\'></bws-error-page>'
                }
            },
            data: {
                analytics: 'bws:web:page not found',
                prerender: {
                    name: 'prerender-status-code',
                    value: '404'
                },
                richer_relevance: {
                    type: 'ERROR_PAGE',
                    data: {}
                },
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        const currentMetaData = pageMetadataService.getCurrentMetadata();
                        currentMetaData.meta404 = {
                            name: 'prerender-status-code',
                            content: '404'
                        };
                        return currentMetaData;
                    }
                ]
            }
        })
        .state('shop.500error', {
            url: '/error',
            parent: 'root',
            resolve: {
                deps: ['$ocLazyLoad', '$$animateJs', function ($ocLazyLoad, $$animateJs) {
                    console.log($$animateJs);
                    return $ocLazyLoad.load(window.wowModules[6].files[0]);
                }]
            },
            data: {
                prerender: {
                    name: 'prerender-status-code',
                    value: '500'
                },
                richer_relevance: {
                    type: 'ERROR_PAGE',
                    data: {}
                }
            },
            views: {
                'center-panel@': {
                    template: '<bws-error-page error-page=\'500\'></bws-error-page>'
                }
            }
        })
        .state('shop.403error', {
            resolve: {
                deps: ['$ocLazyLoad', '$$animateJs', function ($ocLazyLoad, $$animateJs) {
                    console.log($$animateJs);
                    return $ocLazyLoad.load(window.wowModules[6].files[0]);
                }]
            },
            url: '/unauthorised-error',
            parent: 'root',
            data: {
                prerender: {
                    name: 'prerender-status-code',
                    value: '500'
                }
            },
            views: {
                'center-panel@': {
                    template: '<bws-error-page error-page=\'403\'></bws-error-page>'
                }
            }
        });

    $stateProvider.state('shop.unsubscribeedm', {
        url: '/unsubscribe-edm?shopperID&checksum&documentID',
        views: {
            'left-panel@': {
                controller: [
                    'BreakpointsService', '$scope', function (breakpointsService, $scope) {
                        $scope.showLeftPanel = function () {
                            return breakpointsService.isSmallFormat();
                        };
                    }
                ]
            },
            'center-panel@': {
                template: '<wow-unsubscribe-edm></wow-unsubscribe-edm>'
            }
        }
    });

    $stateProvider.state('shop.unsubscribeedmnew', {
        url: '/unsub?s&c&d',
        views: {
            'left-panel@': {
                controller: [
                    'BreakpointsService', '$scope', function (breakpointsService, $scope) {
                        $scope.showLeftPanel = function () {
                            return breakpointsService.isSmallFormat();
                        };
                    }
                ]
            },
            'center-panel@': {
                template: '<wow-unsubscribe-edm></wow-unsubscribe-edm>'
            }
        }
    });

    //Receipt rewards -- TODO - may be replace by new '/receipt-rewards' route
    $stateProvider.state('shop.receiptrewards', {
        url: '/rr',
        views: {
            'dynamic-content-top@': {
                template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
            },
            'dynamic-content-bottom@': {
                template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
            },
            'aem-view@': {
                template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
            }
        }
    });

    $stateProvider.state('shop.herestoyou', {
        url: '/heres-to-you',
        views: {
            'dynamic-content-top@': {
                template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
            },
            'dynamic-content-bottom@': {
                template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
            },
            'aem-view@': {
                template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
            }
        }
    });

    $stateProvider.state('shop.termsandconditions', {
        url: '/terms-conditions',
        views: {
            'dynamic-content-top@': {
                template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
            },
            'dynamic-content-bottom@': {
                template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
            },
            'aem-view@': {
                template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
            }
        }
    });

    $stateProvider.state('shop.termsandconditions.page', {
        url: '/:page',
        views: {
            'dynamic-content-top@': {
                template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
            },
            'dynamic-content-bottom@': {
                template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
            },
            'aem-view@': {
                template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
            }
        }
    });

    


    // Feature routes
    require('./reviews')($stateProvider);
    require('./specials')($stateProvider, $urlRouterProvider);
    require('./search')($stateProvider);
    require('./inspiration')($stateProvider);
    require('./thedrop')($stateProvider);
    require('./discover')($stateProvider);
    require('./recipes')($stateProvider);
    require('./offergroup')($stateProvider);
    require('./exclusivememeberoffer')($stateProvider);
    require('./myaccount')($stateProvider);
    require('./lists')($stateProvider);
    require('./authentication')($stateProvider);
    require('./checkout')($stateProvider);
    require('./productgroups')($stateProvider);
    require('./accessibility')($stateProvider);
    require('./page.js')($stateProvider);
    require('./locator')($stateProvider, $urlRouterProvider);
    require('./new')($stateProvider);
    require('./hightraffic')($stateProvider);
    require('./instantwins')($stateProvider);
    require('./secureaccount')($stateProvider);
    require('./receiptRewards')($stateProvider);

    //The line below has catch all rules, make sure any new routes are defined above.
    require('./browse')($stateProvider);

    // Old shop Url redirect to landing page
    $urlRouterProvider.when('/Shop/Browse', '/'); 
    // Other states
    $stateProvider.state('styleguide', {
        url: '/styleguide'
    })
        // Catch all for other shop states
        .state('shop.others', {
            url: '/*path'
        });


    // for browsers that doesn't support html5 url add / for root route
    $urlRouterProvider.when('', '/');

    $urlRouterProvider.otherwise('/Error');
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/index.js
 **/